"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isInviteLink(object) {
    return checkInviteLink(object).fulfilled;
}
exports.isInviteLink = isInviteLink;
function checkInviteLink(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("projectId"), Check_1.hasString("projectName"), Check_1.hasBoolean("isValid"), Check_1.hasNumber("expiration")).withOptions(options).explain();
}
exports.checkInviteLink = checkInviteLink;
//# sourceMappingURL=InviteLink.js.map